export enum OfferingSelectionOperator {
  electricity = 'electricity',
  gas = 'gas',
  resa = 'resa',
  swde = 'swde',
  tvPhoneInternet = 'tvPhoneInternet',
  proximus = 'proximus',
  orange = 'orange',
  proximusAndOrange = 'proximusAndOrange',
}